import React from 'react';

import AndesMessageIntervention from './messageintervention-chunk';
import useListingDisclaimer from './hooks/use-listing-disclaimer-hook';

const ChunkListingDisclaimer = () => {
  const listingDisclaimerProps = useListingDisclaimer();
  const { text } = listingDisclaimerProps || {};

  return text ? <AndesMessageIntervention intervention={listingDisclaimerProps} /> : null;
};

export default ChunkListingDisclaimer;
